import { axiosPath, globalAxios, coreInstance, merchantInstance } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    title: null
  },
  mutations: {
    getTitle(state, title) {
      state.title = title;
    }
  },
  actions: {
    axiosPathDeleteData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return axiosPath
        .delete(url, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res.data == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    coreInstanceDeleteData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return coreInstance
        .delete(url, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res.data == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    coreInstancePostData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return coreInstance
        .post(url, form, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res.data == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },

    coreCommissionPostData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return coreInstance
        .post(url, form, axiosConfig)
        .then(res => {
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    coreInstancePutData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return coreInstance
        .put(url, form, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res.data == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    coreInstanceGetData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return coreInstance
        .get(url, axiosConfig)
        .then(res => {
          try {
            if (
              res.data.msg === 0 || res.data.msg === 1 || res.data.msg === 2 || res.data.status === false
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    merchantDeleteData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return merchantInstance
        .delete(url, axiosConfig)
        .then(res => {
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    merchantPostData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return merchantInstance
        .post(url, form, axiosConfig)
        .then(res => {
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    merchantPutData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return merchantInstance
        .put(url, form, axiosConfig)
        .then(res => {
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    merchantGetData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return merchantInstance
        .get(url, axiosConfig)
        .then(res => {
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    axiosPathPutData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return axiosPath
        .put(url, form, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    axiosPathPostData({ dispatch }, { url, form }) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return axiosPath
        .post(url, form, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res.data == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    axiosPathGetData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return axiosPath
        .get(url, axiosConfig)
        .then(res => {
          try {
            if (
              typeof res.data.msg == "number" &&
              (res.data.msg == 0 || res.data.msg == 1 || res.data.msg == 2)
            ) {
              dispatch("checkMessage", res.data.msg, { root: true });
              return false;
            }
          } catch (err) {
            if (res == false) {
              dispatch("checkMessage", 2, { root: true });
              return false;
            }
          }
          return res.data;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    globalAxiosGetData({ dispatch }, url) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token")
        }
      };
      return globalAxios
        .get(url, axiosConfig)
        .then(res => {
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {}
};
